import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Button,
    Card,
    CardBody,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Col,
    Spinner,
} from 'reactstrap';
import { authenticate } from './dispatcher';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const authError = useSelector(state => state?.authReducer?.error);
    const loading = useSelector(state => state?.authReducer?.isLoading);
    

    const handleLogin = async (e) => {
        e.preventDefault();
        const data = {
            emailId: email,
            password: password
        };
        dispatch(authenticate(data, navigate));
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && email && password) {
            handleLogin(e);
        }
    };

    return (
        <Col lg="5" md="7" >
            <Card className=" shadow border-0" >
                <CardBody className="px-lg-5 py-lg-5">
                    <Form role="form" onKeyPress={handleKeyPress}>
                        <FormGroup className="mb-3">
                            <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <i className="ni ni-email-83" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                    placeholder="Email"
                                    type="email"
                                    autoComplete="new-email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className='ml-2'
                                />
                            </InputGroup>
                        </FormGroup>
                        <FormGroup>
                            <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <i className="ni ni-lock-circle-open" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                    placeholder="Password"
                                    type={showPassword ? 'text' : 'password'}
                                    autoComplete="new-password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                     className='ml-2'
                                />

                                {password && (
                                    <InputGroupAddon addonType="append">
                                        <InputGroupText onClick={togglePasswordVisibility} style={{ cursor: 'pointer' }}>
                                            {/* <i className={showPassword ? 'ni ni-eye-off' : 'ni ni-eye'} /> */}
                                            <i className={`fa fa-eye${showPassword ? '' : '-slash'} mr-3`} />
                                        </InputGroupText>
                                    </InputGroupAddon>
                                )}
                            </InputGroup>
                        </FormGroup>

                        <div className="text-center">
                            <Button
                                color="primary"
                                type="button"
                                onClick={handleLogin}
                                disabled={loading || !email || !password}
                            >
                                {loading ? <Spinner size="sm" /> : 'Sign in'}
                            </Button>
                        </div>
                    </Form>
                </CardBody>
            </Card>
        </Col>
    );
};

export default Login;
